import React from 'react';

/**
 * The footer's only remaining content was a second copy of the Boston Energy
 * logo, which already sits in the header on every page. With that removed
 * nothing is left to render - the links and contact blocks were commented out
 * long ago - so the component renders nothing rather than an empty grey band
 * that costs vertical space on every screen.
 *
 * It is kept as a no-op component because ~15 pages import and render it;
 * leaving it in place means any future footer content has one home again.
 */
const Footer: React.FC = () => null;

export default Footer;
